<template>
  <button class="player__btn">
    <!-- PREV   -->
    <svg
      v-if="type == 'prev'"
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.583 20.7207C12.3564 20.7207 13.0068 20.1318 13.0068 19.0596V13.9971C13.1211 14.4189 13.4375 14.7793 13.9648 15.0869L22.9736 20.3779C23.3516 20.6064 23.6855 20.7207 24.0723 20.7207C24.8457 20.7207 25.4961 20.1318 25.4961 19.0596V8.22266C25.4961 7.15039 24.8457 6.56152 24.0723 6.56152C23.6855 6.56152 23.3516 6.67578 22.9736 6.9043L13.9648 12.1953C13.4375 12.5029 13.1211 12.8545 13.0068 13.2764V8.22266C13.0068 7.15039 12.3652 6.56152 11.5918 6.56152C11.1963 6.56152 10.8711 6.67578 10.4844 6.9043L1.47559 12.1953C0.807617 12.5908 0.482422 13.0391 0.482422 13.6367C0.482422 14.2256 0.816406 14.7002 1.47559 15.0869L10.4844 20.3779C10.8623 20.6064 11.1963 20.7207 11.583 20.7207Z"
        fill="#1C1C1E"
      />
    </svg>
    <!-- PLAY -->
    <svg
      v-if="type == 'play'"
      class="icon-play"
      width="48"
      height="48"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.3418 21.3711C9.71094 21.3711 10.0361 21.2393 10.4404 21.002L20.8203 14.999C21.5762 14.5596 21.8926 14.2168 21.8926 13.6631C21.8926 13.1094 21.5762 12.7754 20.8203 12.3271L10.4404 6.32422C10.0361 6.08691 9.71094 5.95508 9.3418 5.95508C8.62109 5.95508 8.11133 6.50879 8.11133 7.37891V19.9473C8.11133 20.8262 8.62109 21.3711 9.3418 21.3711Z"
        fill="#1C1C1E"
      />
    </svg>
    <!-- PAUSE -->
    <svg
      v-if="type == 'pause'"
      class="icon-pause"
      width="48"
      height="48"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.63185 20.9668H11.6973C12.5322 20.9668 12.9629 20.5361 12.9629 19.7012V7.60742C12.9629 6.75488 12.5322 6.35059 11.6973 6.3418H9.63185C8.79688 6.3418 8.36622 6.77246 8.36622 7.60742V19.7012C8.35743 20.5361 8.7881 20.9668 9.63185 20.9668ZM16.3115 20.9668H18.3682C19.2031 20.9668 19.6338 20.5361 19.6338 19.7012V7.60742C19.6338 6.75488 19.2031 6.3418 18.3682 6.3418H16.3115C15.4678 6.3418 15.0459 6.77246 15.0459 7.60742V19.7012C15.0459 20.5361 15.4678 20.9668 16.3115 20.9668Z"
        fill="#1C1C1E"
      />
    </svg>
    <!-- NEXT -->
    <svg
      v-if="type == 'next'"
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.91895 20.7207C4.30566 20.7207 4.63965 20.6064 5.01758 20.3779L14.0264 15.0869C14.5449 14.7793 14.8701 14.4189 14.9844 13.9883V19.0596C14.9844 20.1318 15.6348 20.7207 16.4082 20.7207C16.7949 20.7207 17.1201 20.6064 17.5068 20.3779L26.5156 15.0869C27.1748 14.7002 27.5088 14.2256 27.5088 13.6367C27.5088 13.0391 27.1836 12.5908 26.5156 12.1953L17.5068 6.9043C17.1201 6.67578 16.7861 6.56152 16.3994 6.56152C15.626 6.56152 14.9844 7.15039 14.9844 8.22266V13.2764C14.8701 12.8545 14.5537 12.5029 14.0264 12.1953L5.01758 6.9043C4.63965 6.67578 4.30566 6.56152 3.91895 6.56152C3.14551 6.56152 2.49512 7.15039 2.49512 8.22266V19.0596C2.49512 20.1318 3.14551 20.7207 3.91895 20.7207Z"
        fill="#1C1C1E"
      />
    </svg>
    <!-- VOLUME ON -->
    <svg
      v-if="type == 'volumeOn'"
      width="28"
      height="28"
      viewBox="0 0 475.082 475.081"
      xml:space="preserve"
    >
      <g>
        <g>
          <path
            d="M200.999,63.952c-4.946,0-9.229,1.812-12.847,5.426l-95.074,95.075H18.276c-4.952,0-9.234,1.812-12.85,5.424
            C1.809,173.493,0,177.778,0,182.726v109.63c0,4.949,1.809,9.233,5.426,12.848c3.619,3.617,7.902,5.427,12.85,5.427h74.798
            l95.074,95.078c3.617,3.61,7.9,5.424,12.847,5.424c4.952,0,9.234-1.813,12.85-5.424c3.617-3.614,5.426-7.901,5.426-12.847V82.228
            c0-4.948-1.809-9.234-5.422-12.85C210.23,65.764,205.951,63.952,200.999,63.952z"
          />
          <path
            d="M316.769,277.936c8.093-12.467,12.135-25.93,12.135-40.395s-4.042-27.992-12.135-40.556
            c-8.094-12.562-18.791-21.41-32.121-26.551c-1.902-0.949-4.284-1.427-7.139-1.427c-4.944,0-9.232,1.762-12.847,5.282
            c-3.61,3.521-5.427,7.852-5.427,12.99c0,3.997,1.143,7.376,3.432,10.137c2.283,2.762,5.041,5.142,8.282,7.139
            c3.23,1.998,6.468,4.188,9.708,6.567c3.238,2.38,5.996,5.758,8.278,10.135c2.276,4.38,3.426,9.804,3.426,16.277
            c0,6.471-1.143,11.896-3.426,16.276c-2.282,4.381-5.04,7.755-8.278,10.14c-3.24,2.379-6.478,4.569-9.708,6.567
            c-3.241,1.992-5.999,4.377-8.282,7.132c-2.282,2.765-3.432,6.143-3.432,10.14c0,5.144,1.816,9.47,5.427,12.99
            c3.614,3.521,7.902,5.288,12.847,5.288c2.854,0,5.236-0.479,7.139-1.424C297.978,299.304,308.679,290.403,316.769,277.936z"
          />
          <path
            d="M377.728,318.194c16.18-24.646,24.273-51.531,24.273-80.654c0-29.124-8.094-56.005-24.273-80.666
            c-16.177-24.645-37.6-42.583-64.241-53.815c-2.471-0.95-4.948-1.427-7.416-1.427c-4.948,0-9.236,1.809-12.854,5.426
            c-3.613,3.616-5.424,7.898-5.424,12.847c0,7.424,3.713,13.039,11.139,16.849c10.657,5.518,17.888,9.705,21.693,12.559
            c14.089,10.28,25.077,23.173,32.976,38.686c7.898,15.514,11.848,32.026,11.848,49.537c0,17.512-3.949,34.023-11.848,49.536
            c-7.898,15.516-18.894,28.407-32.976,38.684c-3.806,2.857-11.036,7.043-21.693,12.563c-7.426,3.809-11.139,9.424-11.139,16.847
            c0,4.948,1.811,9.236,5.424,12.847c3.617,3.621,7.991,5.432,13.131,5.432c2.286,0,4.668-0.483,7.139-1.428
            C340.128,360.783,361.551,342.844,377.728,318.194z"
          />
        </g>
      </g>
    </svg>
    <!-- VOLUME OFF -->
    <svg
      v-if="type == 'volumeOff'"
      width="20px"
      height="20px"
      viewBox="0 0 475.082 475.081"
      xml:space="preserve"
    >
      <g>
        <g>
          <path
            d="M200.999,63.952c-4.946,0-9.229,1.812-12.847,5.426l-95.074,95.075H18.276c-4.952,0-9.234,1.812-12.85,5.424
            C1.809,173.493,0,177.778,0,182.726v109.63c0,4.949,1.809,9.233,5.426,12.848c3.619,3.617,7.902,5.427,12.85,5.427h74.798
            l95.074,95.078c3.617,3.61,7.9,5.424,12.847,5.424c4.952,0,9.234-1.813,12.85-5.424c3.617-3.614,5.426-7.901,5.426-12.847V82.228
            c0-4.948-1.809-9.234-5.422-12.85C210.23,65.764,205.951,63.952,200.999,63.952z"
          />
        </g>
      </g>
    </svg>
    <!-- REPEAT -->
    <svg
      v-if="type == 'repeat'"
      width="20"
      height="20"
      version="1.1"
      id="Layer_1"
      x="0px"
      y="0px"
      viewBox="0 0 512 512"
      xml:space="preserve"
    >
      <g id="XMLID_2_">
        <path
          id="XMLID_6_"
          class="st0"
          d="M384.4,39.4v78.8H177.2c-67,0-112.6,22.8-136.3,59.9s-26.8,82.7-26.8,127.6l51.2-41
          c2.4-24.4,7.9-44.9,16.5-59.1c14.2-22.1,37.8-37,94.5-37h207.2v78.8l128.4-104L384.4,39.4z M497,207.2l-51.2,41
          c-2.4,24.4-7.9,44.9-16.5,59.1c-14.2,22.1-37.8,37-94.5,37H128.4v-78.8L0,370.2l128.4,102.4v-78.8h206.4
          c67,0,112.6-22.8,136.3-59.9C494.7,297,497,251.3,497,207.2z"
        />
      </g>
    </svg>

    <!-- REPEAT-ONCE -->
    <svg
      v-if="type == 'repeat-once'"
      width="20"
      height="20"
      version="1.1"
      id="Layer_1"
      viewBox="0 0 512 512"
      style="enable-background: new 0 0 512 512"
      xml:space="preserve"
    >
      <g id="XMLID_2_">
        <path
          id="XMLID_8_"
          class="st0"
          d="M378.1,40.2v77.2h-204c-65.4,0-110.3,22.1-133.9,59.1c-23.6,36.2-26,81.1-26,125.2l50.4-41
        c2.4-23.6,7.9-44.1,16.5-58.3c14.2-22.1,37-37,92.9-37h203.2v77.2l126-102.4L378.1,40.2z M404.1,256
        c-59.9,0-107.9,48.8-107.9,107.9c0,59.9,48,107.9,107.9,107.9S512,423.8,512,363.9C512,304.8,463.2,256,404.1,256z M126,262.3
        L0,364.7l126,100.8v-77.2h148.9c-1.6-7.9-2.4-15.8-2.4-24.4s0.8-16.5,2.4-24.4H126V262.3z M423,301.7v126h-29.1v-100h-25.2v-22.1
        L423,301.7z"
        />
      </g>
    </svg>
    <!-- MIX-TRACK -->
    <svg
      v-if="type == 'track-mix'"
      width="20"
      height="16"
      viewBox="0 0 22 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.338867 13.3564C0.338867 13.9805 0.804688 14.4199 1.47266 14.4199H3.54688C5.11133 14.4199 6.06055 13.9541 7.12402 12.6885L9.11914 10.3154L11.0791 12.6533C12.1689 13.9541 13.2412 14.4287 14.8145 14.4287H16.3789V16.3535C16.3789 16.8809 16.7129 17.2148 17.249 17.2148C17.4863 17.2148 17.7061 17.127 17.8818 16.9863L21.3447 14.1035C21.7754 13.752 21.7666 13.1807 21.3447 12.8291L17.8818 9.9375C17.7061 9.78809 17.4863 9.7002 17.249 9.7002C16.7129 9.7002 16.3789 10.0342 16.3789 10.5615V12.2842H14.8584C13.8652 12.2842 13.25 11.959 12.5293 11.1064L10.4902 8.68945L12.5381 6.25488C13.2676 5.38477 13.8301 5.08594 14.8057 5.08594H16.3789V6.83496C16.3789 7.3623 16.7129 7.69629 17.249 7.69629C17.4863 7.69629 17.7061 7.6084 17.8818 7.46777L21.3447 4.58496C21.7754 4.2334 21.7666 3.66211 21.3447 3.31055L17.8818 0.418945C17.7061 0.269531 17.4863 0.181641 17.249 0.181641C16.7129 0.181641 16.3789 0.515625 16.3789 1.04297V2.94141H14.8232C13.1973 2.94141 12.1689 3.39844 11.0176 4.78711L9.11914 7.0459L7.12402 4.68164C6.06055 3.41602 5.0498 2.94141 3.48535 2.94141H1.47266C0.804688 2.94141 0.338867 3.38965 0.338867 4.01367C0.338867 4.6377 0.813477 5.08594 1.47266 5.08594H3.40625C4.35547 5.08594 4.98828 5.40234 5.70898 6.26367L7.73926 8.68066L5.70898 11.1064C4.97949 11.9678 4.4082 12.2842 3.46777 12.2842H1.47266C0.813477 12.2842 0.338867 12.7324 0.338867 13.3564Z"
        fill="#1C1C1E"
      />
    </svg>
  </button>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
  name: "i-button",
  props: {
    type: {
      type: String,
      required: true,
    },
  },
});
</script>

<style lang="scss" scoped></style>
